import footerTranslation from './index.json';

export default footerTranslation;
